module.exports = __webpack_public_path__ + "static/media/pdf-icon.209ce0c7.png";